import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EfSwiperCardBundle, { EfSwiperCardBundleProps } from '@elem/ui/ef-swiper-card-bundle';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import { dataLocal } from './../configs';
import { useState, useEffect } from 'react';
import { getSolarRecommand } from '@/service/solar-calculator';

export default function Bundles() {
    const { t } = useLang('rapid.bundles');
    const { locale = 'jp' } = useRouter();
    const data = dataLocal[locale];
    const { data1, data2 } = data;

    const [data1State, setData1State] = useState<EfSwiperCardBundleProps[]>(data1);
    const [data2State, setData2State] = useState<EfSwiperCardBundleProps[]>(data2);

    const getAsynItem = async (item: EfSwiperCardBundleProps, sub?: any) => {
        const { productId, variantId } = sub ? sub : item.info;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    if (sub) {
                        sub.discountPrice = res?.data?.price;
                        sub.originalPrice = res?.data?.compareAtPrice ?? res?.data?.price;
                        sub.inventory = res?.data?.inventoryQuantity;
                        sub.inventoryPolicy = res?.data?.inventoryPolicy;
                        // sub.linkMore = `https://${locale}.ecoflow.com/${res?.data?.handle}`;
                        if (res?.data?.productTitle || res?.data?.skuTitle) {
                            sub.title = res?.data?.productTitle || res?.data?.skuTitle;
                        }
                    } else {
                        item.info.discountPrice = res?.data?.price;
                        item.info.originalPrice = res?.data?.compareAtPrice ?? res?.data?.price;
                        item.info.inventory = res?.data?.inventoryQuantity;
                        item.info.inventoryPolicy = res?.data?.inventoryPolicy;
                        // sub.info.linkMore = `https://${locale}.ecoflow.com/${res?.data?.handle}`;
                        if (res?.data?.productTitle || res?.data?.skuTitle) {
                            item.info.title = res?.data?.productTitle || res?.data?.skuTitle;
                        }
                    }
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        [data1State, data2State].map((data: EfSwiperCardBundleProps, k: number) => {
            const tempData = JSON.parse(JSON.stringify(data));
            let promises: any[] = [];
            tempData?.map((item: EfSwiperCardBundleProps) => {
                if (item?.info?.productId && item?.info?.variantId) {
                    promises.push(getAsynItem(item?.info));
                }
                if (item?.items && item?.items) {
                    item?.items?.map((i: any, _: number) => {
                        i?.imgs?.map((sub: any, _: number) => {
                            if (sub?.productId && sub?.variantId) {
                                promises.push(getAsynItem(item, sub));
                            }
                        });
                    });
                }
            });
            Promise.all(promises)
                .then(() => {
                    switch (k) {
                        case 0:
                            setData1State(tempData);
                            break;
                        case 1:
                            setData2State(tempData);
                            break;
                        default:
                            break;
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        });
    }, []);

    return (
        <div className={styles.bundles}>
            <EfSpec className="spec" />
            <EfTitle hasAnimation={false}>{t('A_title')}</EfTitle>
            <ul className="items">
                {data1State?.map((item: EfSwiperCardBundleProps, k: number) => (
                    <EfSwiperCardBundle {...item} key={k} list_name={t('A_title')} />
                ))}
            </ul>
            <EfSpec className="spec" />
            <EfTitle hasAnimation={false}>{t('B_title')}</EfTitle>
            <ul className="lists">
                {data2State?.map((item: EfSwiperCardBundleProps, k: number) => (
                    <EfSwiperCardBundle {...item} key={k} list_name={t('B_title')} />
                ))}
            </ul>
            <EfSpec className="spec" />
        </div>
    );
}
